/* eslint-disable import/order */
import 'babel-polyfill';
import React, { Fragment } from 'react';
import 'url-polyfill';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import * as EventSourcePolyfill from 'eventsource';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import apolloClient from '@src/graphql/apollo';
import '@src/sentry';
import store, { history } from './redux';
import { Routes } from './Routes';
import './styles.scss';

import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';

window.EventSource = window.EventSource || EventSourcePolyfill;

ReactDOM.render(
  <Fragment>
    <audio
      id="notification"
      preload="true"
      src="/assets/notification.mp3"
      style={{
        display: 'none',
      }}
    />

    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ApolloProvider client={apolloClient}>
          <Routes />
        </ApolloProvider>
      </ConnectedRouter>
    </Provider>
  </Fragment>,
  document.getElementById('employer-app'),
);
